/**
 * Firestore schema barrel. Re-exports all schemas and default factories.
 * @module firebase/schema
 */

export * from './userSchema';
export * from './productSchema';
export * from './messagingSchema';
export * from './reviewSchema';
export * from './adminSchema';
export * from './miscSchema';
